import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'my-app-layout',
  templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit{

  constructor(){

  }
  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// /Users/jihun.lee/Work/git-repos/client-accounting-intra-web/src/app/layout/layout.component.ts